import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateDiscount = props => {
  return (
    <Create
// @ts-ignore
      title='Create Discount'
      fields={fields}
      apiPath='admin/discounts'
      successRedirectPath={resource => `/ecommerce/discounts/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateDiscount
